<section class="section TRS pdf-page-wrapper">
  <header>
    <h2 class="secondary-heading secondary-heading--blue"
    [innerText]="'Total Rewards Summary' | translate"></h2>
    <p class="TRS__subheading" [innerText]="
      'Your paycheck is just one piece of the puzzle—your rewards summary shows the full picture of your earnings, benefits, and perks, so you can see and understand everything you receive as part of your employment.' | translate
    "></p>
  </header>

  <!-- Rewards section -->
  <div class="TRS__sub-section TRS__sub-section--rewards">
    <header class="TRS__sub-section__header">
      <h3 class="tertiary-heading" [innerText]="rewardsSummaryHeading"></h3>
      <p class="TRS__sub-section__header__description">
        This is a summary of the annual value of your benefits, including
        contributions from both you and SOLV Energy.
      </p>
      <button class="btn--clean-green" onclick="window.print()">
        <span [innerText]="'Print summary' | translate"> </span>
        <img alt="Print TRS" src="/assets/img/icons/printer.svg"/>
      </button>
    </header>

    <div class="TRS__rewards">
      <!-- Annual Total Value Overview Radial Bar Chart -->
      <svg class="TRS__rewards__chart" viewBox="0 0 300 300">
        @for (segment of annualTotalValues; track segment) {
          <ng-container>
            <!-- Background Circle -->
            <circle [attr.r]="segment.radius" cx="150" cy="150" fill="none" stroke="#EAEAEA"
              stroke-width="10"/>
            <!-- Segment (Fill) Circle -->
            <circle [attr.r]="segment.radius" [attr.stroke-dasharray]="segment.strokeDashArray"
              [attr.stroke-dashoffset]="segment.strokeDashOffset" [attr.stroke]="segment.strokeColor"
              [attr.transform]="'rotate(' + (-90 + segment.rotationOffset) + ' 150 150)'" cx="150"
              cy="150" fill="none" stroke-width="10"/>
          </ng-container>
        }
      </svg>

      <div class="TRS__rewards__metrics">
        <div
          class="TRS__rewards__metrics__metric TRS__rewards__metrics__metric--highlighted poke-out-right">
          <h4 class="TRS__rewards__metrics__metric__label">Total Compensation & Rewards</h4>
          <span class="TRS__rewards__metrics__metric__value"
          [innerText]="annualCompensationAndRewardsTotal" coreFinancial></span>
        </div>
        <div class="TRS__rewards__metrics__metric poke-out-right">
          <h4 class="TRS__rewards__metrics__metric__label">Annual Compensation</h4>
          <span class="TRS__rewards__metrics__metric__value" [innerText]="annualCompensationTotal"
          coreFinancial></span>
        </div>
        <div class="poke-out-right">
          <div class="TRS__rewards__metrics__metric">
            <h4 class="TRS__rewards__metrics__metric__label">Total Annual Rewards</h4>
            <span class="TRS__rewards__metrics__metric__value" [innerText]="annualRewardsTotal"
            coreFinancial></span>
          </div>

          <div class="TRS__rewards__metrics__pillars">
            @for (segment of annualTotalValues; track segment) {
              <div class="TRS__rewards__metrics__pillars__card" [class]="
                    'TRS__rewards__metrics__pillars__card--' + segment.type
                  ">
                <span class="TRS__rewards__metrics__pillars__card__label"
                [innerText]="getAnnualTotalValueCardLabel(segment.type)"></span>
                <span [innerText]="segment.value"
                class="TRS__rewards__metrics__pillars__card__value" coreFinancial></span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Show full table -->
    @if (!isMobileTable) {
      <div class="table-wrapper TRS__rewards-table-wrapper">
        <table class="table TRS__rewards-table">
          <thead class="TRS__rewards-table__header">
            <th [innerText]="'Plan' | translate"></th>
            <th [innerText]="'Your Contribution' | translate"></th>
            <th [innerText]="'Company Contribution' | translate" colspan="2"></th>
          </thead>
          @for (pillar of pillars; track pillar; let idx = $index) {
            <thead (click)="togglePillar(idx)" (keydown)="keyboardTogglePillar($event,idx)"
              class="expandable-header TRS__rewards-table__pillar-row" tabindex="0">
              <th class="TRS__rewards-table__pillar-row__label"
              [innerText]="getAnnualTotalValueCardLabel(pillar)"></th>
              <th [innerText]="getPillarEETotal(pillar)" coreFinancial></th>
              <th [innerText]="getPillarERTotal(pillar)" coreFinancial></th>
              <th>
                <img [src]="pillarExpandedStates[idx] ? '/assets/img/icons/chevron-up.svg' : '/assets/img/icons/chevron-down.svg'"
                  alt=""
                  class="TRS__rewards-table__pillar-row__chevron-icon">
              </th>
            </thead>
            @if (pillarExpandedStates[idx] || isPrintRequested) {
              <tbody class="TRS__rewards-table__pillar-row-body"
                [attr.data-expanded]="pillarExpandedStates[idx]">
                @for (data of getPillarPlans(pillar); track data) {
                  <tr>
                    <td>
                      <div class="TRS__rewards-table__pillar-row-body__container">
                        <div class="TRS__rewards-table__pillar-row-body__container__heading">
                          <span [innerText]="getPlanTitle(data)" [ngClass]="{'has-tooltip' : data.tooltip}"></span>
                          <!-- Tooltip -->
                          @if (data.tooltip) {
                            <div
                              class="TRS__rewards-table__pillar-row-body__container__heading__tooltip">
                              <img alt=""
                                class="TRS__rewards-table__pillar-row-body__container__heading__tooltip__icon hide-for-print" src="/assets/img/icons/info-icon-outline.svg"/>
                              <div [innerText]="data.tooltip"
                              class="TRS__rewards-table__pillar-row-body__container__heading__tooltip__window"></div>
                            </div>
                          }
                        </div>
                        @if (data.link) {
                          <span class="TRS__rewards-table__pillar-row-body__link">
                            <a [href]="data.link.href" [innerText]="data.link.text"
                              class="TRS__rewards-table__pillar-row-body__link__content"
                            target="_blank"></a>
                            <img class="TRS__rewards-table__pillar-row-body__link__icon hide-for-print"
                              alt="" src="/assets/img/icons/external-link-icon.svg"/>
                          </span>
                          @if (data.tooltip) {
                            <span [innerText]="'*' + data.tooltip"
                            class="tooltip-msg-for-print print-only"></span>
                          }
                        }
                      </div>
                    </td>
                    <td [innerText]="authUser.data[data.ee ?? ''] ?? 0" coreFinancial></td>
                    <td [innerText]="authUser.data[data.er ?? ''] ?? 0" coreFinancial></td>
                    <td></td>
                  </tr>
                }
              </tbody>
            }
          }
        </table>
      </div>
    }

    <!-- Show abbreviated table -->
    @if (isMobileTable) {
      <div class="table-wrapper TRS__rewards-table-wrapper">
        <table class="table TRS__rewards-table TRS__rewards-table--mobile">
          <thead class="TRS__rewards-table__header">
            <th [innerText]="'Your Contribution' | translate"></th>
            <th [innerText]="'Company Contribution' | translate" colspan="2"></th>
          </thead>
          @for (pillar of pillars; track pillar; let idx = $index) {
            <thead (click)="togglePillar(idx)" (keydown)="keyboardTogglePillar($event,idx)"
              class="expandable-header TRS__rewards-table__pillar-row" tabindex="0">
              <tr>
                <th class="TRS__rewards-table__pillar-row__label"
                [innerText]="getAnnualTotalValueCardLabel(pillar)"></th>
              </tr>
              <tr>
                <th class="TRS__rewards-table__pillar-row__value"
                [innerText]="getPillarEETotal(pillar)" coreFinancial></th>
                <th class="TRS__rewards-table__pillar-row__value" colspan="2"
                [innerText]="getPillarERTotal(pillar)" coreFinancial></th>
                <th>
                  <img [src]="pillarExpandedStates[idx] ? '/assets/img/icons/chevron-up.svg' : '/assets/img/icons/chevron-down.svg'"
                    alt=""
                    class="TRS__rewards-table__pillar-row__chevron-icon">
                </th>
              </tr>
            </thead>
            @if (pillarExpandedStates[idx]) {
              <tbody class="TRS__rewards-table__pillar-row-body"
                [attr.data-expanded]="pillarExpandedStates[idx]">
                @for (data of getPillarPlans(pillar); track data) {
                  <tr class="TRS__rewards-table__pillar-row-body__heading">
                    <td colspan="3">
                      <div class="TRS__rewards-table__pillar-row-body__container">
                        <div class="TRS__rewards-table__pillar-row-body__container__heading">
                          <span [innerText]="getPlanTitle(data)"></span>
                          <!-- Tooltip -->
                          @if (data.tooltip) {
                            <div
                              class="TRS__rewards-table__pillar-row-body__container__heading__tooltip">
                              <img
                                alt=""
                                class="TRS__rewards-table__pillar-row-body__container__heading__tooltip__icon" src="/assets/img/icons/info-icon-outline.svg"/>
                              <div
                                [innerText]="data.tooltip"
                              class="TRS__rewards-table__pillar-row-body__container__heading__tooltip__window"></div>
                            </div>
                          }
                        </div>
                        @if (data.link) {
                          <span class="TRS__rewards-table__pillar-row-body__link">
                            <a [href]="data.link.href" [innerText]="data.link.text"
                              class="TRS__rewards-table__pillar-row-body__link__content"
                            target="_blank"></a>
                            <img class="TRS__rewards-table__pillar-row-body__link__icon hide-for-print"
                              alt="" src="/assets/img/icons/external-link-icon.svg"/>
                          </span>
                        }
                      </div>
                    </td>
                  </tr>
                  <tr class="TRS__rewards-table__pillar-row-body__body">
                    <td [innerText]="authUser.data[data.ee ?? ''] ?? 0" coreFinancial></td>
                    <td [innerText]="authUser.data[data.er ?? ''] ?? 0" colspan="2" coreFinancial>
                    </td>
                    <td></td>
                  </tr>
                }
              </tbody>
            }
          }
        </table>
      </div>
    }

    <p class="TRS__sub-section__description">The compensation and benefit values shown in this statement are annualized estimates and may
      not reflect actual amounts paid or received. Actual compensation may vary based on factors such
      as hours worked, bonus eligibility, benefit elections, or employment changes throughout the
      year. This statement is provided for informational purposes only and does not constitute a
    contract or guarantee of compensation.</p>
  </div>

  <!-- My Compensation History -->
  <core-block-compensation-history></core-block-compensation-history>

  <!-- Paid Time Off -->
  <core-block-paid-time-off></core-block-paid-time-off>
</section>

<!--Blank page added after Total Rewards Summary and before back cover when odd number of pages present-->
@if (isBlankPageNeededForPdf) {
  <section class="section--pdf-blank pdf-page-wrapper"></section>
}
